import type { RouteObject } from 'react-router';

import { ROUTES } from '@/layouts/routes/routes';
import { NotFound } from '@/views/generalError/notFound/NotFound.comp.tsx';

import { RootLayout } from './RootLayout.comp';
import { RouteErrorBoundary } from './RouteErrorBoundary.comp';
import { RouteGuard } from './RouteGuard.comp';

export const APP_ROUTES: RouteObject[] = [
  {
    children: [
      { element: <NotFound />, path: '*' },
      ...ROUTES.map(({ component, path, roles }) => ({
        element: <RouteGuard rolesWithAccess={roles}>{component}</RouteGuard>,
        path,
      })),
    ],
    element: <RootLayout />,
    ErrorBoundary: RouteErrorBoundary,
  },
];
